import { defineComponent } from '@vue/composition-api';
import Layout from '@component/layout/mobile/error/notfound/index.vue';

export default defineComponent({
    components: {
        Layout,
    },
    setup() {
        
    },
});